module.exports = __webpack_public_path__ + "img/nhdl.b1200079.jpg";